<div class="specs-tab">
  <div class="row">
    <!-- Left Column -->
    <div class="col-md-6">
      <div class="form-group">
        <label class="col-md-6 control-label" for="fuelType">FUEL TYPE</label>
        <div class="col-md-6 inputSpace">
          <select
            id="fuelType"
            name="fuelType"
            class="form-control"
            [(ngModel)]="tractor.fuelType"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          >
            <option value="">Select Fuel Type</option>
            <option *ngFor="let option of fuelTypeOptions" [ngValue]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label fuel-card-label" for="fuelCardNumber"
          >FUEL CARD NUMBER</label
        >
        <div class="col-md-6 inputSpace">
          <input
            id="fuelCardNumber"
            name="fuelCardNumber"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.tchekCardNo"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="engineManufacturer">ENGINE MANUFACTURER</label>
        <div class="col-md-6 inputSpace">
          <input
            id="engineManufacturer"
            name="engineManufacturer"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.engineManufacturer"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="engineModel">ENGINE MODEL</label>
        <div class="col-md-6 inputSpace">
          <input
            id="engineModel"
            name="engineModel"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.engineModel"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="engineSerialNumber">ENGINE SERIAL NUMBER</label>
        <div class="col-md-6 inputSpace">
          <input
            id="engineSerialNumber"
            name="engineSerialNumber"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.engineSerialNumber"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="engineYearWarranty">ENGINE YEAR WARRANTY</label>
        <div class="col-md-6 inputSpace">
          <input
            id="engineYearWarranty"
            name="engineYearWarranty"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.engineYearWarranty"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="afterTreatmentMiles"
          >AFTER TREATMENT MILES</label
        >
        <div class="col-md-6 inputSpace">
          <input
            id="afterTreatmentMiles"
            name="afterTreatmentMiles"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.afterTreatmentMilesWarranty"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="treatmentYear">TREATMENT YEAR</label>
        <div class="col-md-6 inputSpace">
          <input
            id="treatmentYear"
            name="treatmentYear"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.afterTreatmentYearWarranty"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="col-md-6">
      <!-- Dimensions Row -->
      <div class="dimensions-row">
        <div class="dimension-group">
          <label class="control-label" for="length">LENGTH</label>
          <div class="inputSpace">
            <input
              id="length"
              name="length"
              type="text"
              class="form-control dimension-input"
              [(ngModel)]="tractor.length"
              (ngModelChange)="onFieldChange()"
              [disabled]="!isEditMode"
            />
          </div>
        </div>
        <div class="dimension-group">
          <label class="control-label" for="width">WIDTH</label>
          <div class="inputSpace">
            <input
              id="width"
              name="width"
              type="text"
              class="form-control dimension-input"
              [(ngModel)]="tractor.width"
              (ngModelChange)="onFieldChange()"
              [disabled]="!isEditMode"
            />
          </div>
        </div>
        <div class="dimension-group">
          <label class="control-label" for="height">HEIGHT</label>
          <div class="inputSpace">
            <input
              id="height"
              name="height"
              type="text"
              class="form-control dimension-input"
              [(ngModel)]="tractor.height"
              (ngModelChange)="onFieldChange()"
              [disabled]="!isEditMode"
            />
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="ladenWeight">LADEN WEIGHT</label>
        <div class="col-md-6 inputSpace">
          <input
            id="ladenWeight"
            name="ladenWeight"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.ladenWeight"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="unladenWeight">UNLADEN WEIGHT</label>
        <div class="col-md-6 inputSpace">
          <input
            id="unladenWeight"
            name="unladenWeight"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.unladenWeight"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="axles">AXLES</label>
        <div class="col-md-6 inputSpace">
          <input
            id="axles"
            name="axles"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.axles"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="steerTireSize">STEER TIRE SIZE</label>
        <div class="col-md-6 inputSpace">
          <input
            id="steerTireSize"
            name="steerTireSize"
            type="number"
            class="form-control"
            [(ngModel)]="tractor.steerTireSize"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="driveTireSize">DRIVE TIRE SIZE</label>
        <div class="col-md-6 inputSpace">
          <input
            id="driveTireSize"
            name="driveTireSize"
            type="number"
            class="form-control"
            [(ngModel)]="tractor.driveTireSize"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="accumulatedMiles">ACCUMULATED MILES</label>
        <div class="col-md-6 inputSpace">
          <input
            id="accumulatedMiles"
            name="accumulatedMiles"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.accumulatedMiles"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>
    </div>
  </div>
</div>
